
import React from 'react'

import './styles/Avatar.scss'

const Avatar = (props) => {
  return <div title={props.name} className="avatar" style={{
      backgroundImage: `url('${props.pic}')`,
      backgroundSize: 'cover'
    }}></div>
}

Avatar.defaultProps = {
  pic: '',
  name: ''
}

export default Avatar;



// WEBPACK FOOTER //
// ./src/components/user/Avatar.jsx